import SumsubWebSdk from "@sumsub/websdk-react";
import React, { useEffect, useState } from "react";
import { getUserDetails } from "sr/helpers/functions/getUserDetails";
import { getCleaner } from "sr/utils/api/cleaner/getCleaner";
import { createAccessToken } from "sr/utils/api/cleaner/kyc/createAccessToken";
import CleanerType from "../type/CleanerType";
import ContentWithSpinner from "sr/layout/common/ContentWithSpiner";

export const KYC = () => {
    const [accessToken, setAccessToken] = useState<string>()
      const [userId, setUserId] = useState<string>('')
       const [cleanerData, setCleanerData] = useState<CleanerType>(null)
       const [loader, setLoader] = useState(true)

      useEffect(()=>{
            const {user_id} = getUserDetails()
            setUserId(user_id)
        },[])
const fetchCleaner = async (cleanerId) => {
    const queryParams = new URLSearchParams()
    queryParams.append('id', cleanerId)
      const cleanerData = await getCleaner(queryParams);
      if (cleanerData?.success) {
        setCleanerData(cleanerData?.data);
      }
    };
    useEffect(()=>{
if(userId){
    fetchCleaner(userId)
}
    },[userId])
        const fetchToken = async (userId, cleanerData)=>{
            try {
                const payload = {
    externalUserId: userId,   
     levelName: "id-and-liveness",
     type:'individual',
     info:{ firstName: cleanerData?.first_name,
    lastName: cleanerData?.last_name}
                }
    const res = await createAccessToken(payload)
    if(res?.success===true){
            setAccessToken(res.data?.token)
            setLoader(false)
    }   
    else {

    }  
} 
    catch(e){

    }      
        }
        useEffect(()=>{
                if(userId && cleanerData){
                    fetchToken(userId, cleanerData)
                }
        },[userId, cleanerData])
        const accessTokenExpirationHandler = () => {

};
const config = {
  lang: "en",
  email: cleanerData?.email,
};

const options = {
  useModal: true,
  uiConf: { showHeader: true },
};
const messageHandler = (message) => {
  
  if (message.action === 'reviewCompleted') {
    // e.g. notify backend or update user status
  }
};
const errorHandler = (error) => {
  
};

  return(<>
  <ContentWithSpinner loader={loader} height="min-h-[50vh]">
  <div>
    {accessToken && 
    <SumsubWebSdk
  accessToken={accessToken}
  expirationHandler={accessTokenExpirationHandler}
  config={config}
  options={options}
  onMessage={messageHandler}
  onError={errorHandler}
/>
}
  </div>;
  </ContentWithSpinner>
  </>)
};
